import {ACTION_CODE} from './_actionCode';
import {CustomerService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'GET_ALL_MERGED_CUSTOMERS_CONTRACTORS';

export async function getAllMergedCustomersContractors(
    userData: Record<string, string>,
    params = "",
    page = 1,
) {
    try {
        LoggerService.logInfo('Action - getAllMergedCustomersContractors - Start');

        const getAllMergedCustomersContractorsResult = await CustomerService.getAllMergedCustomersContractors(userData, params, page);

        const {data, metadata} = getAllMergedCustomersContractorsResult;

        LoggerService.logInfo('Action - getAllMergedCustomersContractors - End - Success');

        return ResultModel.newSuccessResult(data, metadata);
    }
    catch (error) {
        LoggerService.logInfo('Action - getAllMergedCustomersContractors - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récuperation de la liste des clients et fournisseurs.',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
